(function(){
    angular.module('looping-action.dir', [])
        .directive('loopingAction', ['$rootScope', '$compile', '$templateCache', 'plumbService', 'helpers', 'canvasService','CANVAS_OPTS', '$timeout', loopingAction]);

    function loopingAction($rootScope, $compile, $templateCache, plumbService, helpers, canvasService, CANVAS_OPTS, $timeout) {
        return {
            scope: {},
            controller: ['$scope', function($scope){
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                //When we save a the form
                $scope.save = function(dummy){
                    var parentData = helpers.getConnectionById($scope.connections.parent);
                    if(parentData){
                        parentData.children = [];
                        parentData.children.push($scope.connections.id);
                        helpers.updateConnections(parentData);
                    }
                    //Save to the global canvas object
                    helpers.updateConnections($scope.connections);

                    //Displays th form data
                    $scope.displayList = false;
                    //Displays action menu
                    $scope.displaySubMenu = false;

                    //Save Journey to template
                    canvasService.saveJourneyStorge('journey', JSON.stringify($rootScope.connections), true);

                    //Set Back to autoSave
                    $scope.isElegibleForUpdate = true;
                    //Remove Activate Error since its being able to save
                    $scope.displayActivateError = false;
                    $scope.displayErrorBlink = false;

                    // Listener to show or hide the delete arrow or add connection arrow
                    $rootScope.$on('showDeleteArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showDeleteArrow = condition;
                    });

                    $rootScope.$on('showConnectionArrow_' + $scope.connections.id, function (event, condition) {
                        $scope.showConnectionArrow = condition;
                    });
                };

                $scope.$on('closeConfigMenus', function() {
                    if($scope.displayList || $scope.displaySubMenu) {
                        $scope.displaySubMenu = false;
                        $scope.contMenuConfigs = 0;
                    }
                });
            }],
            link: function (scope, elem) {
                //Scope data initialization
                scope.displayList = true;
                scope.displayError = false;
                scope.displaySubMenu = false;
                scope.isElegibleForUpdate = true;
                scope.wasSave = false;

                //load existing
                if ($rootScope.cElement) {
                    // bullet proving multiple targets
                    if (scope.connections){
                        if(document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    scope.connections = $rootScope.cElement;
                    delete $rootScope.cElement;
                    scope.isElegibleForUpdate = true;

                    var template = $templateCache.get('actions/looping');

                    //Create template and compile it
                    var content = $compile(template)(scope);
                    $('.canvas').append(content);

                    $rootScope.$on('saveActionLoopingData' + scope.connections.id, function(evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    scope.save();
                }

                // when a directive is clicked
                $(elem).click(function (evt) {
                    // bullet proving multiple targets
                    if (scope.connections){
                        if(document.getElementById(scope.connections.id)) {
                            delete $rootScope.cElement;
                            return false;
                        }
                    }

                    //Load Template
                    var template = $templateCache.get('actions/looping'),
                        now = new Date(),
                        lastElemId = plumbService.getLastElemClicked(),
                        lastElement = helpers.getConnectionById(lastElemId);


                    //Start Connection obj
                    scope.connections = {
                        id: 'element_' + now.getTime(),
                        top: (lastElement.type == 'RectangleConnection') ? (lastElement.top - 18) : lastElement.top + 25,
                        left: lastElement.left + 250,
                        type: 'Looping',
                        data: {delayTime: '1', allowedLoops: '3'},
                        elemClass: {loopingAction: 'looping-action'},
                        elemName: 'Loop',
                        parent: lastElement.id,
                        //Triger: #4F4FC9 // Action: #B21877 // Condition: #FF7F57
                        color: '#B21877'
                    };

                    //Create template and compile it
                    scope.$apply(function () {
                        var content = $compile(template)(scope);
                        $(elem).parents('.canvas').append(content);
                    });


                    $rootScope.$on('saveActionLoopingData' + scope.connections.id, function(evt, conn) {
                        scope.tempConn = angular.copy(scope.connections);
                        scope.connections = angular.copy(conn);
                        scope.save();
                    });

                    // Listener when user cancel the add the node of delay
                    $rootScope.$on('deleteLoopingNode' + scope.connections.id, function () {
                        scope.deleteElement();
                    });

                    //Hide hide menus
                    $rootScope.$emit('closeMenus', true);
                    scope.displayList = true;

                    scope.save();
                    plumbService.connectElements(lastElement, scope.connections);

                    $rootScope.$emit('coach-register', 'tipLooping');
                });

                scope.deleteElement = function() {
                    var idx = $rootScope.unsavedData.indexOf(scope.connections.id);
                    if (idx > -1) {
                        $rootScope.unsavedData.splice(idx, 1);
                    }
                    scope.displayActivateError = false;
                    scope.displayErrorBlink = false;
                    plumbService.deleteElements(scope.connections);
                    scope.connections = null;
                    scope.currentDelayConn = null;
                    $rootScope.delayConns = $rootScope.delayConns || [];
                    $rootScope.delayConns.splice(scope.currentDelayConn, 1);

                    if ($rootScope.conn && $rootScope.conn.length === 1 && $rootScope.conn[0].type === 'Entry' ) {
                        $rootScope.activePlus = true;
                    }else {
                        $rootScope.activePlus = false;
                    }
                };

                scope.deleteArrow = function() {
                    if(scope.connections.hasOwnProperty('children')) {
                        scope.hasArrow = false;
                        plumbService.deleteArrows(scope.connections);
                    }
                };
            }
        };
    }
}());



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/looping-action.js